import React from 'react';
import { Tabs } from 'antd';

import SpintouchManagementAdaptive from "./SpintouchManagementAdaptive";
import {
  SettingOutlined
} from '@ant-design/icons';

class Spintouch extends React.Component {

  state = {
    activeTab: 'spintouch'
  }

  render() {

    const tabItems = [
      {
        key: 'spintouch',
        label: (
          <span>
            <SettingOutlined />
            Gestion Spintouch
          </span>
        ),
        children: <SpintouchManagementAdaptive />
      }
    ];

    return (
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '16px' }}>
        <Tabs
          activeKey={this.state.activeTab}
          onChange={(key) => this.setState({ activeTab: key })}
          items={tabItems}
          size="large"
        />
      </div>
    );
  }
}

export default Spintouch;
